import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import { useSelector } from 'react-redux';
const Loader = ({ loading = false }) => {
    const isLoading = useSelector((state) => state.toolbar.loading) || loading
    return (
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, width: 'inherit' }}
            open={isLoading}
        >
            <CircularProgress />
        </Backdrop>
    )
}
export default Loader;
